module.exports = __webpack_public_path__ + "img/question13c2.3be98323.png";